var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{attrs:{"status":"403","title":"Access denied"}},[_c('p',[_vm._v("\n\t\tThe request was valid, but the server is refusing action.\n\t\tYou might not have the necessary permissions for this resource.\n\t")]),_vm._v(" "),_c('btn',{attrs:{"primary":"","raised":"","to":{ name: 'home' }}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }